import { Clock, LogOut, RefreshCw } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { trpc } from "@/lib/trpc";
import { Navigate } from "react-router-dom";

// 24/09/2026 — a tela dizia só "aguardando o administrador", sem nome do
// sistema e sem dizer a quem pedir; e o "Sair" era um link GET para uma rota
// que só aceita POST. Desde 24/09 o pedido cai sozinho na fila da central
// (auth/google.ts → acessos-centrais.ts), e a liberação vale na hora: o papel
// é relido do banco a cada requisição, então "Verificar de novo" basta.
export function AguardandoAutorizacao() {
  const { user, isLoading } = useAuth();
  const utils = trpc.useUtils();

  if (isLoading) return <div className="flex h-screen items-center justify-center text-slate-500">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "pendente") return <Navigate to="/dashboard" replace />;

  async function sair() {
    await fetch("/api/auth/logout", { method: "POST", credentials: "include" }).catch(() => undefined);
    window.location.href = "/login";
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-amber-50 to-white px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="items-center text-center">
          <div className="mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
            <Clock className="h-8 w-8 text-amber-600" />
          </div>
          <CardTitle className="text-2xl">Aguardando autorização</CardTitle>
          <CardDescription>Seu pedido de acesso ao RH Vet Center Miguel foi recebido.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <div className="rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
            Olá <strong>{user.name}</strong>!<br />
            O pedido já está na fila de aprovação da administração do Vet Center Miguel. Quem libera o
            acesso é o Bryan ou a Thayanni. Se for urgente, avise um deles e informe o e-mail abaixo.
          </div>
          <p className="text-xs text-slate-500">
            E-mail cadastrado: <span className="font-mono text-slate-700">{user.email}</span>
          </p>
          <Button className="w-full" onClick={() => utils.auth.me.invalidate()}>
            <RefreshCw className="mr-1 h-4 w-4" />
            Já fui liberado? Verificar de novo
          </Button>
          <Button variant="outline" className="w-full" onClick={sair}>
            <LogOut className="mr-1 h-4 w-4" />
            Sair
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
